import type { TaskWithDisabled } from "./TaskSelector.types";

export const filterOptions = (
  options: TaskWithDisabled[],
  { inputValue }: { inputValue: string }
) =>
  options.filter((option) =>
    option.task_name?.toLowerCase().includes(inputValue.toLowerCase())
  );

export const isOptionEqualToValue = (
  option: TaskWithDisabled,
  value: TaskWithDisabled
) => option.task_name === value.task_name;
